<template>
	<span class="mnt-icon" :class="'mnt-icon_' + name">
		<svg v-if="name === 'info'" v-bind="attrs">
			<circle cx="12" cy="12" r="9" />
			<path d="M12 11v5" />
			<path d="M12 8h.01" />
		</svg>
		<svg v-else-if="name === 'user-x'" v-bind="attrs">
			<circle cx="10" cy="8" r="3.5" />
			<path d="M3.5 19a6.5 6.5 0 0 1 10.2-5.3" />
			<path d="M16.5 15.5l4 4" />
			<path d="M20.5 15.5l-4 4" />
		</svg>
		<svg v-else-if="name === 'user'" v-bind="attrs">
			<circle cx="12" cy="8" r="3.5" />
			<path d="M5 19.5a7 7 0 0 1 14 0" />
		</svg>
		<svg v-else-if="name === 'headset'" v-bind="attrs">
			<path d="M4 14v-2a8 8 0 0 1 16 0v2" />
			<path d="M4 13h1.6a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1H4.8A1.8 1.8 0 0 1 3 16.7v-1.9A1.8 1.8 0 0 1 4.8 13z" />
			<path d="M20 13h-1.6a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h.8a1.8 1.8 0 0 0 1.8-1.8v-1.9A1.8 1.8 0 0 0 19.2 13z" />
			<path d="M18 18.5v.7a2.3 2.3 0 0 1-2.3 2.3H13" />
		</svg>
		<svg v-else-if="name === 'lock'" v-bind="attrs">
			<rect x="4.5" y="10.5" width="15" height="10" rx="2" />
			<path d="M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7" />
			<path d="M12 14.5v2" />
		</svg>
		<svg v-else-if="name === 'exchange'" v-bind="attrs">
			<path d="M4 8.5h13" />
			<path d="M14 5.5l3 3-3 3" />
			<path d="M20 15.5H7" />
			<path d="M10 12.5l-3 3 3 3" />
		</svg>
		<svg v-else-if="name === 'bank'" v-bind="attrs">
			<path d="M3.5 9.5 12 4l8.5 5.5" />
			<path d="M5.5 9.5v9" />
			<path d="M18.5 9.5v9" />
			<path d="M9.5 12.5v6" />
			<path d="M14.5 12.5v6" />
			<path d="M3 20.5h18" />
		</svg>
		<svg v-else-if="name === 'x-circle'" v-bind="attrs">
			<circle cx="12" cy="12" r="8.5" />
			<path d="M9.5 9.5l5 5" />
			<path d="M14.5 9.5l-5 5" />
		</svg>
		<svg v-else-if="name === 'question'" v-bind="attrs">
			<circle cx="12" cy="12" r="9" />
			<path d="M9.6 9.4A2.4 2.4 0 0 1 14.4 10c0 1.6-2.4 2-2.4 3.4" />
			<path d="M12 16.5h.01" />
		</svg>
		<svg v-else-if="name === 'scales'" v-bind="attrs">
			<path d="M12 3.5 19.5 6v6c0 4-3.2 7-7.5 8.5C7.7 19 4.5 16 4.5 12V6z" />
			<path d="M8.7 10.2h6.6" />
			<path d="M12 9.4v5.9" />
			<path d="M10.2 15.3h3.6" />
			<path d="M8.7 10.4 7.4 13h2.6z" />
			<path d="M15.3 10.4 14 13h2.6z" />
		</svg>
		<svg v-else-if="name === 'megaphone'" v-bind="attrs">
			<path d="M4 10.5v3a1 1 0 0 0 1 1h2l6 3.5V6l-6 3.5H5a1 1 0 0 0-1 1z" />
			<path d="M16.5 9.5a4 4 0 0 1 0 5" />
			<path d="M19 7.5a7 7 0 0 1 0 9" />
			<path d="M7 14.5V19" />
		</svg>
		<svg v-else-if="name === 'document'" v-bind="attrs">
			<path d="M6 3.5h7l5 5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1z" />
			<path d="M13 3.5v5h5" />
			<path d="M8.5 13.5h7" />
			<path d="M8.5 17h4.5" />
		</svg>
	</span>
</template>

<script>
export default {
	name: 'MaintenanceIcon',
	props: {
		name: {
			type: String,
			required: true,
		},
	},
	computed: {
		attrs() {
			return {
				viewBox: '0 0 24 24',
				fill: 'none',
				stroke: 'currentColor',
				'stroke-width': '1.5',
				'stroke-linecap': 'round',
				'stroke-linejoin': 'round',
				'aria-hidden': 'true',
				focusable: 'false',
			};
		},
	},
};
</script>
